import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import config from 'config';
import { authSelectors } from 'redux/auth';

const useHelpUrl = () => {

  const { i18n } = useTranslation();

  const workspaceType = useSelector(state => authSelectors.getWorkspace(state)?.type);

  const params = new URLSearchParams({ locale: i18n.language, ...(workspaceType && { type: workspaceType }) });

  return `${config.apiUrl}/api/help?${params}`;
};

export default useHelpUrl;
